module.exports = __webpack_public_path__ + "img/f703a3b.jpg";